import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Section = styled.div.attrs(() => ({
  className: e2eClasses('home.information.section')
}))`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, 1fr);
  &:nth-child(even) {
    > div {
      grid-column: 1;
      width: 100%;
      justify-self: flex-end;
      ${({ centered }) => !centered && 'align-items: flex-start'};
    }
    img {
      grid-column: 2;
    }
  }
  ${mediaQueries.tablet`
    grid-template-columns: repeat(1, 1fr);
    display: block;
  `};
`
export const Img = styled.img.attrs(() => ({
  className: e2eClasses('home.information.image')
}))`
  width: 100%;
  height: 430px;
  object-fit: cover;

  ${mediaQueries.mobile`
    height: 250px;
  `};
`
export const Items = styled.div.attrs(() => ({
  className: e2eClasses('home.information.itemBox')
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};
  ${({ withIcons }) => (withIcons ? 'padding: 60px' : 'padding: 60px 70px;')};
  justify-content: center;
  display: flex;
  height: 430px;
  align-items: ${({ withIcons }) => (withIcons ? 'center' : 'baseline')};
  flex-direction: column;

  ${mediaQueries.tablet`
    height: 400px;
    max-width: none;
    align-items: center;
    padding: 45px 40px;

    ${mediaQueries.mobile`
      height: auto;
    `};
  `};
`
export const Title = styled.label.attrs(() => ({
  className: e2eClasses('home.information.title')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  display: flex;
  justify-content: center;
  font-size: 24px;
  text-align: center;
`

export const TitleBlue = styled.label.attrs({
  className: e2eClasses('home.information.title')
})`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  display: flex;
  justify-content: center;
  font-size: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.blue};
`

export const ButtonContainer = styled.div`
  max-width: 200px;
  width: 100%;
  ${({ paddingTop }) => paddingTop && 'padding-top: 20px;'};
`
export const Row = styled.div.attrs(() => ({
  className: e2eClasses('home.information.row')
}))`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(${({ repeat }) => repeat}, 1fr);
  width: 100%;
  margin: 45px 0 55px 0;

  ${mediaQueries.tablet`
    margin: 30px 0 40px 0;

    ${mediaQueries.mobile`
      grid-auto-flow: row;
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 30px;
    `};
  `};
`
export const Column = styled.div.attrs(() => ({
  className: e2eClasses('home.information.column')
}))`
  display: flex;
  align-items: center;
  flex-direction: column;
`
export const Icon = styled.img.attrs(() => ({
  className: e2eClasses('home.information.icon')
}))`
  max-height: 35px;
  max-width: 35px;
`
export const IconContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  height: 100px;
  width: 100px;
  border-radius: 50%;
  box-shadow: 0 1px 5px 0 ${({ theme }) => theme.shadow.black06};
  margin-bottom: 20px;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`
